/**
 * Created by Bob.Bao on 2017/12/18.
 */
export const PAGE_BIDS = 'CURRENT_PAGE_BIDS' // use namespace to diff the type, eg.: 'bid/CURRENT_PAGE_BIDS'

export const PAGE_FORM = 'SUBMIT_PAGE_PAGE_FORM' //

export const ACCOUNT_FORM = 'supplier/ACCOUNT'// 供应商登录信息

export const BASIC_FORM = 'supplier/BASIC'// 供应商登录信息

export const REG_STEP = 'supplier/STEP' // 供应商注册步骤

export const SELECT_PROVINCE = 'meta/PROVINCE_ID'
export const FETCH_PROVINCES = 'meta/PROVINCES'
export const FETCH_APTS = 'meta/APTS'
export const FETCH_CITIES = 'meta/CITIES'
export const FETCH_CONTACTS = 'contact/LIST'
export const FETCH_MANAGERS = 'manager/LIST'
export const FETCH_SERVICEAS = 'service_area/LIST'
export const FETCH_SPSS = 'category/LIST'
export const FETCH_LinksToSps = 'category/LINKS_LIST'
export const FETCH_PRODUCT_TYPES = 'product_types/all'
export const FETCH_COMPANY_TYPES = 'company_types/all'
export const FETCH_STOCK_INFO = 'supplier/stock_info'
export const FETCH_OTHER_INFO = 'supplier/other_info'
export const FETCH_AUDIT_INFO = 'supplier/audit_info'
export const ADD_GYSF = 'gysf/ADD'
export const FETCH_GYSFJS = 'gysf/LIST'
export const ADD_MANAGER = 'manager/ADD'
export const EDIT_MANAGER = 'manager/EDIT'
export const REMOVE_MANAGER = 'manager/REMOVE'
export const ADD_CONTACT = 'contact/ADD'
export const EDIT_CONTACT = 'contact/EDIT'
export const REMOVE_CONTACT = 'contact/REMOVE'
export const ADD_SERVICE_AREA = 'service_area/ADD'
export const EDIT_SERVICE_AREA = 'service_area/EDIT'
export const REMOVE_SERVICE_AREA = 'service_area/REMOVE'
export const ADD_CATEGORY = 'category/ADD'
export const EDIT_CATEGORY = 'category/EDIT'
export const REMOVE_CATEGORY = 'category/REMOVE'
export const ADD_LINKPERSONS = 'linkpersons/ADD'
export const ADD_SERVICEAS = 'serviceas/ADD'
export const ADD_SPSS = 'spss/ADD'
export const REMOVE_SPSS = 'spss/REMOVE'//for register
export const ADD_SALES = 'yearsales/ADD'
export const EDIT_SALES = 'yearsales/EDIT'
export const REMOVE_SALES = 'yearsales/REMOVE'
export const ADD_ACHIEVE = 'achievement/ADD'
export const EDIT_ACHIEVE = 'achievement/EDIT'
export const REMOVE_ACHIEVE = 'achievement/REMOVE'
export const ADD_APTITUDE = 'aptitude/ADD'
export const EDIT_APTITUDE = 'aptitude/EDIT'
export const REMOVE_APTITUDE = 'aptitude/REMOVE'
export const UPDATE_TAXPAYER_TYPE='update/taxpayer-type'
export const UPDATE_COMPANY_TYPE='update/company-type'
export const REMOVE_PASS2 = 'update/remove-password2'
export const MAKE_REG_FORM = 'supplier/make-register'

export const SUPPLIER_BASIC_FORM = 'supplier/basic-form'
export const SUPPLIER_USER_INFO = 'supplier/user-info'

// for bankinfo
export const ADD_BANKINFO = 'bankinfo/ADD'
export const EDIT_BANKINFO = 'bankinfo/EDIT'
export const REMOVE_BANKINFO = 'bankinfo/REMOVE'
export const FETCH_BANKINFO = 'bankinfo/LIST'

export const SET_IS_SHOW_BASIC  = 'isShowBasic'
export const SET_HAS_YRZ = 'hasYrz'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js